module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"title": "Search Response",
	"description": "The search API response",
	"type": "object",
	"required": [
		"numberOfResults",
		"countOnly",
		"limit",
		"offset",
		"results"
	],
	"properties": {
		"numberOfResults": {
			"type": "integer"
		},
		"countOnly": {
			"type": "boolean"
		},
		"limit": {
			"type": "integer"
		},
		"offset": {
			"type": "integer"
		},
		"results": {
			"type": "object",
			"patternProperties": {
				".+": {
					"type": "object",
					"properties": {
						"isin": {
							"type": "string"
						},
						"securitiesIdentifierDe": {
							"type": [
								"string",
								"null"
							]
						},
						"name": {
							"type": "string"
						},
						"nameShort40": {
							"type": "string"
						},
						"currencyIso": {
							"type": "string"
						},
						"launchDateShareClass": {
							"type": [
								"string",
								"null"
							]
						},
						"issuerName": {
							"type": "string"
						},
						"issuerNameShort": {
							"type": "string"
						},
						"issuerCommonTerm": {
							"type": "string"
						},
						"dividendsPayout": {
							"type": "string"
						},
						"priceDate": {
							"type": [
								"string",
								"null"
							]
						},
						"priceCurrencyIso": {
							"type": [
								"string",
								"null"
							]
						},
						"focusAssetId": {
							"type": "string"
						},
						"focusAsset": {
							"type": "string"
						},
						"focusRegion": {
							"type": "string"
						},
						"yieldUsage": {
							"type": "string"
						},
						"urlKiid": {
							"type": [
								"string",
								"null"
							]
						},
						"fundId": {
							"type": "number"
						},
						"issuerId": {
							"type": "number"
						},
						"riskLevelFww": {
							"type": [
								"number",
								"null"
							]
						},
						"riskLevelSrri": {
							"type": [
								"number",
								"null"
							]
						},
						"volumeEur": {
							"type": [
								"number",
								"null"
							]
						},
						"isEtf": {
							"type": "number"
						},
						"isIndexFund": {
							"type": "number"
						},
						"priceBid": {
							"type": [
								"number",
								"null"
							]
						},
						"priceNav": {
							"type": [
								"number",
								"null"
							]
						},
						"priceOffer": {
							"type": [
								"number",
								"null"
							]
						},
						"focusRegionId": {
							"type": "number"
						}
					}
				}
			}
		}
	}
}